"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var ui_components_2 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
// import { useAddCurrency } from '@l2p/swr-hooks'
// import { InputCheckbox } from '@l2p/ui-components'
var AddCurrency = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, react_1.useState)(null), activeCurrency = _a[0], setActiveCurrency = _a[1];
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    // const { addCurrency, isSubmitting } = useAddCurrency({
    //   successAction: closeWindow,
    // })
    var addCurrencyHandler = (0, react_1.useCallback)(function () {
        // if (activeCurrency) addCurrency({ name: activeCurrency })
    }, []);
    return (react_1.default.createElement(ui_components_2.Modal, { width: "385px", height: "560px", padding: "0" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: t.raw('selectCurrencyToAdd') } })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", onClick: addCurrencyHandler, maxWidth: "280px", 
                    // loading={isSubmitting}
                    disabled: !activeCurrency }, t('addCurrency'))))));
};
exports.default = AddCurrency;
